import KeyAccountLayout from "@/layouts/KeyAccountLayout.vue";

import type { RouteRecordRaw } from "vue-router";

const usersRoutes: RouteRecordRaw[] = [
  {
    path: "/users",
    name: "users",
    component: () => import("@/views/restricted/users/UserListView.vue"),
    meta: {
      layout: KeyAccountLayout,
      menuSelected: "users",
      requiresAuth: true,
      permissions: ["KEY_ACCOUNT_ACCOUNT_READ_PERMISSION"],
    },
  },
];

export default usersRoutes;
